import React, { createContext, useContext, useState, useEffect } from 'react';

const themes = {
  purple: {
    name: 'Morado', bg: '#050505', card: '#0C0C10', elevated: '#16161E',
    primary: '#9333EA', primaryHover: '#A855F7', accent: '#C084FC', light: '#D8B4FE',
    textPrimary: '#FFFFFF', textSecondary: '#B8B8C0', textMuted: '#6B6B78',
    border: 'rgba(147, 51, 234, 0.18)', borderHover: 'rgba(147, 51, 234, 0.45)',
    success: '#34D399', warning: '#FBBF24', error: '#F87171',
    gradient: 'linear-gradient(135deg, #9333EA 0%, #C084FC 50%, #581C87 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(147,51,234,0.35) 0%, rgba(192,132,252,0.25) 60%, rgba(12,12,16,0.9) 100%)',
    preview: ['#050505', '#9333EA', '#C084FC', '#D8B4FE']
  },
  mauve: {
    name: 'Mauve', bg: '#050505', card: '#0E0A10', elevated: '#1A1220',
    primary: '#854F6C', primaryHover: '#9E6580', accent: '#DFB6B2', light: '#FBE4D8',
    textPrimary: '#FFFFFF', textSecondary: '#DFB6B2', textMuted: '#6B5060',
    border: 'rgba(133, 79, 108, 0.2)', borderHover: 'rgba(133, 79, 108, 0.5)',
    success: '#34D399', warning: '#FBBF24', error: '#F87171',
    gradient: 'linear-gradient(135deg, #522B5B 0%, #854F6C 45%, #DFB6B2 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(133,79,108,0.4) 0%, rgba(223,182,178,0.2) 60%, rgba(14,10,16,0.9) 100%)',
    preview: ['#050505', '#522B5B', '#854F6C', '#DFB6B2']
  },
  gold: {
    name: 'Black & Gold', bg: '#050505', card: '#0A0A0E', elevated: '#12121A',
    primary: '#FCA311', primaryHover: '#FFB833', accent: '#FCA311', light: '#FFD580',
    textPrimary: '#FFFFFF', textSecondary: '#D4D4D8', textMuted: '#6B6B78',
    border: 'rgba(252, 163, 17, 0.15)', borderHover: 'rgba(252, 163, 17, 0.4)',
    success: '#34D399', warning: '#FCA311', error: '#F87171',
    gradient: 'linear-gradient(135deg, #14213D 0%, #FCA311 55%, #FFD580 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(252,163,17,0.4) 0%, rgba(20,33,61,0.5) 50%, rgba(10,10,14,0.9) 100%)',
    preview: ['#050505', '#14213D', '#FCA311', '#FFD580']
  },
  teal: {
    name: 'Teal Ocean', bg: '#050505', card: '#080E10', elevated: '#0E1A1C',
    primary: '#0F969C', primaryHover: '#14B0B8', accent: '#6DA5C0', light: '#A0D8E8',
    textPrimary: '#FFFFFF', textSecondary: '#A0C8D8', textMuted: '#4A6878',
    border: 'rgba(15, 150, 156, 0.18)', borderHover: 'rgba(15, 150, 156, 0.45)',
    success: '#34D399', warning: '#FBBF24', error: '#F87171',
    gradient: 'linear-gradient(135deg, #072E33 0%, #0F969C 50%, #6DA5C0 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(15,150,156,0.4) 0%, rgba(109,165,192,0.25) 55%, rgba(8,14,16,0.9) 100%)',
    preview: ['#050505', '#072E33', '#0F969C', '#6DA5C0']
  },
  burgundy: {
    name: 'Burgundy', bg: '#050505', card: '#0C0808', elevated: '#181010',
    primary: '#A02020', primaryHover: '#C03030', accent: '#D4A050', light: '#E0D6B8',
    textPrimary: '#FFFFFF', textSecondary: '#D4C0A0', textMuted: '#6B5040',
    border: 'rgba(160, 32, 32, 0.18)', borderHover: 'rgba(160, 32, 32, 0.45)',
    success: '#34D399', warning: '#D4A050', error: '#F87171',
    gradient: 'linear-gradient(135deg, #4A0808 0%, #A02020 50%, #D4A050 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(160,32,32,0.4) 0%, rgba(212,160,80,0.25) 60%, rgba(12,8,8,0.9) 100%)',
    preview: ['#050505', '#800000', '#B8842C', '#E0D6B8']
  },
  redblack: {
    name: 'Red & Black', bg: '#000000', card: '#0A0606', elevated: '#160A0A',
    primary: '#D40000', primaryHover: '#E61020', accent: '#FFFFFF', light: '#FFE0E0',
    textPrimary: '#FFFFFF', textSecondary: '#E8D8D8', textMuted: '#7A6060',
    border: 'rgba(212, 0, 0, 0.22)', borderHover: 'rgba(212, 0, 0, 0.55)',
    success: '#34D399', warning: '#FBBF24', error: '#D40000',
    gradient: 'linear-gradient(135deg, #000000 0%, #660000 45%, #D40000 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(212,0,0,0.35) 0%, rgba(102,0,0,0.5) 55%, rgba(10,6,6,0.95) 100%)',
    preview: ['#000000', '#660000', '#D40000', '#FFFFFF']
  },
  green: {
    name: 'Green Nature', bg: '#050505', card: '#0A0C08', elevated: '#141810',
    primary: '#7CB800', primaryHover: '#9FD700', accent: '#B8E040', light: '#D8F080',
    textPrimary: '#FFFFFF', textSecondary: '#C8D8A0', textMuted: '#586840',
    border: 'rgba(124, 184, 0, 0.18)', borderHover: 'rgba(124, 184, 0, 0.45)',
    success: '#7CB800', warning: '#FBBF24', error: '#F87171',
    gradient: 'linear-gradient(135deg, #1a2608 0%, #7CB800 55%, #D8F080 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(124,184,0,0.4) 0%, rgba(184,224,64,0.25) 60%, rgba(10,12,8,0.9) 100%)',
    preview: ['#050505', '#446158', '#9fd700', '#D8F080']
  },
  sunset: {
    name: 'Navy Sunset', bg: '#050505', card: '#0A0A14', elevated: '#121220',
    primary: '#B4182D', primaryHover: '#D42040', accent: '#FDA481', light: '#FFD0B8',
    textPrimary: '#FFFFFF', textSecondary: '#E0B8A0', textMuted: '#685850',
    border: 'rgba(180, 24, 45, 0.18)', borderHover: 'rgba(180, 24, 45, 0.45)',
    success: '#34D399', warning: '#FDA481', error: '#B4182D',
    gradient: 'linear-gradient(135deg, #37415C 0%, #B4182D 50%, #FDA481 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(180,24,45,0.4) 0%, rgba(253,164,129,0.3) 55%, rgba(10,10,20,0.9) 100%)',
    preview: ['#050505', '#37415C', '#B4182D', '#FDA481']
  },
  // ---- 4 New themes (user-requested palettes) ----
  luxuryNavy: {
    name: 'Luxury Navy', bg: '#0A0F1F', card: '#0F1730', elevated: '#162243',
    primary: '#C6A75E', primaryHover: '#D4B873', accent: '#E8DCC8', light: '#F5EFE2',
    textPrimary: '#F5EFE2', textSecondary: '#E8DCC8', textMuted: '#8A9BB8',
    border: 'rgba(198, 167, 94, 0.20)', borderHover: 'rgba(198, 167, 94, 0.55)',
    success: '#9BC79B', warning: '#C6A75E', error: '#E08585',
    gradient: 'linear-gradient(135deg, #1F2A44 0%, #C6A75E 55%, #E8DCC8 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(198,167,94,0.35) 0%, rgba(31,42,68,0.6) 55%, rgba(15,23,48,0.95) 100%)',
    preview: ['#1F2A44', '#E8DCC8', '#C6A75E', '#F5EFE2']
  },
  appleBlossom: {
    name: 'Apple Blossom', bg: '#1A0E0C', card: '#241412', elevated: '#321B17',
    primary: '#B24D37', primaryHover: '#D4664E', accent: '#F78358', light: '#FEBF7C',
    textPrimary: '#FFEEB0', textSecondary: '#FEBF7C', textMuted: '#8F6B5A',
    border: 'rgba(247, 131, 88, 0.22)', borderHover: 'rgba(247, 131, 88, 0.55)',
    success: '#A8C97A', warning: '#FEBF7C', error: '#D4664E',
    gradient: 'linear-gradient(135deg, #482420 0%, #B24D37 35%, #F78358 65%, #FEBF7C 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(247,131,88,0.35) 0%, rgba(178,77,55,0.45) 55%, rgba(36,20,18,0.95) 100%)',
    preview: ['#482420', '#B24D37', '#F78358', '#FFEEB0']
  },
  yellowJet: {
    name: 'Yellow & Jet', bg: '#0F0F0F', card: '#1E1E1E', elevated: '#2A2929',
    primary: '#FFB700', primaryHover: '#FFD000', accent: '#FFD000', light: '#FFE54D',
    textPrimary: '#FFFFFF', textSecondary: '#E5E5E5', textMuted: '#888888',
    border: 'rgba(255, 183, 0, 0.20)', borderHover: 'rgba(255, 183, 0, 0.55)',
    success: '#7CB800', warning: '#FFB700', error: '#F87171',
    gradient: 'linear-gradient(135deg, #0F0F0F 0%, #2A2929 35%, #FFB700 75%, #FFD000 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(255,183,0,0.35) 0%, rgba(68,67,66,0.55) 55%, rgba(15,15,15,0.95) 100%)',
    preview: ['#0F0F0F', '#444342', '#FFB700', '#FFD000']
  },
  blackOrange: {
    name: 'Black & Orange', bg: '#0F0F0F', card: '#1B1B1B', elevated: '#323232',
    primary: '#FC6E20', primaryHover: '#FF843D', accent: '#FFE7D0', light: '#FFF1E0',
    textPrimary: '#FFFFFF', textSecondary: '#FFE7D0', textMuted: '#9A9A9A',
    border: 'rgba(252, 110, 32, 0.20)', borderHover: 'rgba(252, 110, 32, 0.55)',
    success: '#34D399', warning: '#FC6E20', error: '#F87171',
    gradient: 'linear-gradient(135deg, #1B1B1B 0%, #323232 30%, #FC6E20 70%, #FFE7D0 100%)',
    gradientSoft: 'linear-gradient(135deg, rgba(252,110,32,0.35) 0%, rgba(50,50,50,0.6) 55%, rgba(27,27,27,0.95) 100%)',
    preview: ['#1B1B1B', '#323232', '#FC6E20', '#FFE7D0']
  },
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => localStorage.getItem('teko-theme') || 'redblack');
  const theme = themes[currentTheme] || themes.redblack;

  useEffect(() => {
    localStorage.setItem('teko-theme', currentTheme);
    const root = document.documentElement;
    Object.entries({
      '--bg-main': theme.bg, '--bg-card': theme.card, '--bg-elevated': theme.elevated,
      '--color-primary': theme.primary, '--color-primary-hover': theme.primaryHover,
      '--color-accent': theme.accent, '--color-light': theme.light,
      '--text-primary': theme.textPrimary, '--text-secondary': theme.textSecondary,
      '--text-muted': theme.textMuted, '--border-color': theme.border,
      '--border-hover': theme.borderHover, '--color-success': theme.success,
      '--color-warning': theme.warning, '--color-error': theme.error,
    }).forEach(([k, v]) => root.style.setProperty(k, v));
    document.body.style.backgroundColor = theme.bg;
    document.body.style.color = theme.textPrimary;
  }, [currentTheme, theme]);

  return (
    <ThemeContext.Provider value={{ theme, currentTheme, setCurrentTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
